const LocalStorageHelper = {
	getUsername() {
		try {
			const obj = JSON.parse(localStorage.getItem('eqc_admin'));
			return obj.admin.name;
		} catch (e) { }
		return '';
	},
	getEmail() {
		try {
			const obj = JSON.parse(localStorage.getItem('eqc_admin'));
			return obj.admin.email;
		} catch (e) { }
		return '';
	},
	getCrfId() {
		try {
			const obj = JSON.parse(localStorage.getItem('crf'));
			return obj.crf_id;
		} catch (e) {
			return '62e8e33323a80fe530358b62'; // DEFAULT IS MCPF
		}
	},
	getAdminId() {
		try {
			const admin = JSON.parse(localStorage.getItem('eqc_admin'));
			return admin.admin.id;
		} catch (e) { }
		return '';
	},
	getAdminCrfs() {
		const jsonData = JSON.parse(localStorage.getItem('eqc_admin'));
		const { admin_crfs } = jsonData.admin;

		return admin_crfs;
	}
};

export default LocalStorageHelper;
